import { ShippingRateModelAdd } from '@teinor/erp/types/company/config/shipping/shippingCompany/shippingService/shippingRate'
import { ShippingRateCostModelAdd } from '@teinor/erp/types/company/config/shipping/shippingCompany/shippingService/shippingRateCost'
import { RangeTableDataDict } from '../../../../../../../baseComponents/RangeTable'
import { TwinDictionary, dictionaryFromJsonArr } from '../../../../../../../utils/globals/dictionary'
import { ConfigShippingZoneGroupTy } from './types'

type ShippingRatesArrTy = ShippingRateModelAdd[] | ShippingRateCostModelAdd[]

export const parseDictShippingRatesBeforeSubmit = (ranges: RangeTableDataDict, ShippingServiceId: number) => {
    let dictResult: TwinDictionary = {}
    for (const key in ranges) {
        const row = ranges[key]
        if (row.values && row.values.length && row.active) {
            dictResult[key] = { 'price': row.values, 'ShippingZoneGroupId': parseInt(key), ShippingServiceId }
        }
    }
    return dictResult
}

export const joinShippingZonesAndRatesDict = (shippingValuesArr: ShippingRatesArrTy, shippingZones: ConfigShippingZoneGroupTy): RangeTableDataDict => {
    const dataDict = dictionaryFromJsonArr(shippingValuesArr, 'ShippingZoneGroupId', 'price')
    let rangeTableDataDict: RangeTableDataDict = {}
    for (const key in shippingZones) {
        const id = parseInt(key)
        const zone = shippingZones[id]
        rangeTableDataDict[id] = { id, name: zone.name, values: dataDict?.[id], active: dataDict?.[id] ? true : false}
    }
    return rangeTableDataDict
}